import { useEffect, useState, useCallback } from "react";
import API from "../../lib/api";

let cache = null;
let inflight = null;
const listeners = new Set();

const load = () => {
  if (!inflight) {
    inflight = API.get("/client-hub/me").then(({ data }) => {
      cache = data;
      listeners.forEach((fn) => fn(data));
      return data;
    }).finally(() => { inflight = null; });
  }
  return inflight;
};

export const refreshPortalMe = () => { cache = null; return load(); };

export function usePortal() {
  const [me, setMe] = useState(cache);
  const [error, setError] = useState(null);
  useEffect(() => {
    listeners.add(setMe);
    if (!cache) load().catch((e) => setError(e?.response?.data?.detail || "Could not load your portal"));
    return () => listeners.delete(setMe);
  }, []);
  const refresh = useCallback(() => refreshPortalMe(), []);
  const perms = me?.permissions || {};
  return { me, loading: !me && !error, error, refresh, perms, tier: me?.user?.tier, client: me?.client, user: me?.user, counts: me?.counts || {} };
}

/* Lightweight "is this a main client with sub-clients?" flag for shared chrome (nav). Only fetches when `enabled`
   (i.e. the signed-in user is a client) so admin/supplier sessions never hit /client-hub/me. */
export function useIsMainClient(enabled) {
  const [isMain, setIsMain] = useState(!!cache?.client?.is_main);
  useEffect(() => {
    if (!enabled) return undefined;
    const fn = (data) => setIsMain(!!data?.client?.is_main);
    listeners.add(fn);
    if (cache) fn(cache); else load().catch(() => {});
    return () => listeners.delete(fn);
  }, [enabled]);
  return enabled && isMain;
}
